import inflection from 'inflection';

export const formatCategory = category => {
  let formattedCategory = category.replace(/_/g, ' ');
  if (formattedCategory === 'general') {
    formattedCategory = 'All Time';
  }
  if (formattedCategory === 'growth at reasonable price') {
    formattedCategory = 'GARP';
  }
  if (formattedCategory === 'last twelve months') {
    formattedCategory = 'LTM';
  }
  return inflection.titleize(formattedCategory);
};
